export default __webpack_public_path__ + "static/media/blog_1.0e5b04c9.jpg";